module.exports = __webpack_public_path__ + "media/packs/images/flags/GY-c7a60051638ea913187a12ba40189f42.svg";